import React from 'react';
import { Modal } from 'react-bootstrap';
import successIcon from 'assets/images/backoffice/online-store/success.svg';
import failedIcon from 'assets/images/backoffice/online-store/failed.svg';
import DropdownSelect from 'components/Fields/ReduxForm/DropdownSelect';
import classNames from 'classnames';
import moment from 'moment';
import { Field, reduxForm } from 'redux-form';
import {
  startSyncingProductValidationFlow,
  startProductExportFlow,
  startPostProductExportFlow,
  shopDetailProductsRequest,
} from 'actions/onlineStore';
import { connect } from 'react-redux';
import Pusher from 'pusher-js';
import { PUSHER_APP_KEY } from 'api/constants';
import { fbProductUploadExportClick } from 'clevertap/onlineStore/facebook';
import { googleProductUploadExportClick } from 'clevertap/onlineStore/google';
import { ONLINE_STORE_CHANNEL } from 'utils/onlineStoreUtils';
import styles from './ProductSyncingResultModal.css';
import ShopDetailProductTable from '../ShopDetailProductTable';

class ProductSyncingResultModal extends React.Component {
  static FILTER_STATUS_DROPDOWN = [
    { id: 'LIVE', name: 'All Live Status' },
    { id: 'FAILED', name: 'All Failed Status' },
  ];

  componentWillUnmount() {
    if (this.channel) {
      this.channel.unbind();
    }
  }

  render() {
    const { shopDetail } = this.props.shop;

    const {
      total_live_items,
      total_failed_items,
      total_pending_items,
    } = shopDetail.item_stats;

    const isFailed =
      total_failed_items > total_live_items + total_pending_items;

    if (shopDetail.channel === 'GOOGLE') {
      ProductSyncingResultModal.FILTER_STATUS_DROPDOWN.push({
        id: 'PENDING',
        name: 'All Pending Status',
      });
    }

    return (
      <Modal
        backdrop="static"
        onHide={this.props.onHide}
        show
        dialogClassName={`${styles.dialog} modal-dialog`}
      >
        <Modal.Header>
          <Modal.Title className={styles['title-modal']}>
            {this.props.title} <b>{this.props.titleBold}</b>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className={classNames(styles['dialog-body'])}>
            <div className={classNames('row', styles['mb-20'])}>
              <div className={classNames('col-md-1')}>
                <img src={isFailed ? failedIcon : successIcon} alt="" />
              </div>
              {this._renderStatus(shopDetail, isFailed)}
              <div className={classNames('col-md-6', styles['align-right'])}>
                Last Upload{' '}
                <span className={classNames(styles['light-bold'])}>
                  {moment(shopDetail.item_last_synced_at).fromNow()}
                </span>
              </div>
            </div>
            <div className={classNames('row')}>
              <div className="col-md-5">
                <Field
                  name="viewProductUploadStatusFilter"
                  component={DropdownSelect}
                  options={ProductSyncingResultModal.FILTER_STATUS_DROPDOWN}
                  defaultOption={{ id: 'ALL', name: 'All Uploaded Status' }}
                  id={styles['status-filter-field']}
                  styles={{ backgroundColor: 'white' }}
                  onChange={this._onChangeType}
                />
              </div>
              <div className={classNames('col-md-7', styles['align-right'])}>
                <button
                  type="button"
                  className={classNames('btn btn-default', styles['btn-white'])}
                  onClick={this._exportProduct}
                >
                  Export Product
                </button>
                <button
                  type="button"
                  className={classNames('btn btn-primary', styles['ml-10'])}
                  onClick={this._reUploadProduct}
                >
                  Reupload Products
                </button>
              </div>
            </div>
            <ShopDetailProductTable />
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className={classNames(styles['dialog-footer'])}>
            <button
              type="button"
              className="btn btn-primary"
              onClick={this.props.onHide}
            >
              Done
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    );
  }

  _renderStatus = (shopDetail, isFailed) => {
    const {
      total_live_items,
      total_failed_items,
      total_pending_items,
    } = shopDetail.item_stats;

    const statusStyle = isFailed ? 'status-failed' : 'status-success';
    const headerText = isFailed ? 'Uploading Failed' : 'Successfully Uploaded';

    const stats = [];
    if (total_live_items > 0) {
      stats.push(`${total_live_items} Live`);
    }
    if (total_pending_items > 0) {
      stats.push(`${total_pending_items} Pending`);
    }
    if (total_failed_items > 0) {
      stats.push(`${total_failed_items} Failed`);
    }

    return (
      <div className={classNames('col-md-5', styles['pl-20'])}>
        <div className={classNames(styles[statusStyle])}>
          <strong>{headerText}</strong>
        </div>
        <div>{stats.join(', ')}</div>
      </div>
    );
  };

  _onChangeType = (_, type) => {
    const { shopDetail } = this.props.shop;
    this.props.dispatch(
      shopDetailProductsRequest(shopDetail.id, 1, type, true)
    );
  };

  _exportProduct = () => {
    const { shopDetail } = this.props.shop;

    if (shopDetail.channel === ONLINE_STORE_CHANNEL.FACEBOOK) {
      fbProductUploadExportClick();
    } else {
      googleProductUploadExportClick();
    }

    this._connectToPusher();
    this.props.dispatch(startProductExportFlow(shopDetail.id));
  };

  _connectToPusher() {
    if (this.channel) {
      this.channel.unbind();
    }

    const { shop, dispatch } = this.props;
    const { shopDetail } = shop;

    const pusher = new Pusher(PUSHER_APP_KEY, {
      cluster: 'ap1',
      encrypted: true,
    });

    this.channel = pusher.subscribe(
      `gostore-shop-ext-${shopDetail.channel.toLowerCase()}-${shopDetail.id}`
    );

    this.channel.bind('exports', () => {
      dispatch(startPostProductExportFlow(shopDetail.id));
    });
  }

  _reUploadProduct = () => {
    const { shopDetail } = this.props.shop;
    this.props.dispatch(
      startSyncingProductValidationFlow(shopDetail.id, false)
    );
  };
}

const mapForm = {
  form: 'filter',
};

function mapStateToProps(state) {
  return {
    shop: state.onlineStore.shop,
  };
}

export default connect(mapStateToProps)(
  reduxForm(mapForm)(ProductSyncingResultModal)
);
